module.exports = "/Public/build/3a080c940926767980a7f93a94febb55.svg";


//////////////////
// WEBPACK FOOTER
// ./data/assets/logo.svg
// module id = 83
// module chunks = 0 1